module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "admin-users"
  }, [_c('div', {
    staticClass: "panelheader border-2"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(" " + _vm._s(_vm.pageName) + " ")]), _vm._v(" "), _c('div', {
    staticClass: "btn-wrapper"
  }, [_c('el-button', {
    attrs: {
      "type": "add"
    },
    on: {
      "click": _vm.onNewUser
    }
  }, [_vm._v("New User")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "users"
  }, [(_vm.newUser) ? _c('div', [_c('newuser', {
    on: {
      "close": _vm.onClose
    }
  })], 1) : (_vm.editUser) ? _c('div', [_c('edituser', {
    attrs: {
      "userData": _vm.userData
    },
    on: {
      "close": _vm.onClose
    }
  })], 1) : _c('div', [(!_vm.reloading) ? _c('usertable', {
    on: {
      "editUser": _vm.onEditUser,
      "deleteUser": _vm.onDeleteUser
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.showDeleteConfirm,
      "width": "50%"
    },
    on: {
      "update:visible": function($event) {
        _vm.showDeleteConfirm = $event
      }
    }
  }, [_c('h3', {
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("\n      Delete User"), (_vm.userToDelete.username) ? _c('span', [_vm._v(" '" + _vm._s(_vm.userToDelete.username) + "'")]) : _vm._e(), _vm._v("?\n    ")]), _vm._v(" "), _c('div', [_vm._v("Are you sure you wish to delete "), (_vm.userToDelete.username) ? _c('span', [_c('strong', [_vm._v("'" + _vm._s(_vm.userToDelete.username) + "'")])]) : _c('span', [_vm._v("this user?")])]), _vm._v(" "), _c('div', [_vm._v("This is "), _c('strong', [_vm._v("permanent")]), _vm._v(" and can't be undone")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.showDeleteConfirm = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.doDelete
    }
  }, [_vm._v("Delete")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d0ed6762","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/Users/Users.vue
// module id = 1147
// module chunks = 0